/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { ic_dashboard } from "react-icons-kit/md/ic_dashboard";
import { ic_settings } from "react-icons-kit/md/ic_settings";
import { ic_info_outline } from "react-icons-kit/md/ic_info_outline";
import { ic_logout } from "react-icons-kit/md/ic_logout";
import { ic_help } from "react-icons-kit/md/ic_help";

import { dashboardStyles, DashboardWidgetItem } from "./shared_components";

interface NavWidgetProps {
  style?: StyleProp<ViewStyle>;
  overviewIsActive: boolean;
  settingsIsActive: boolean;
  reportIssueIsActive: boolean;
  handleLogout: () => void;
  handleShowTutorial: () => void;
  handleShowOverview: () => void;
  handleShowSettings: () => void;
  handleShowReportIssue: () => void;
}

export default function NavWidget({
  style,
  overviewIsActive,
  settingsIsActive,
  reportIssueIsActive,
  handleLogout,
  handleShowTutorial,
  handleShowOverview,
  handleShowSettings,
  handleShowReportIssue,
}: NavWidgetProps) {
  return (
    <View style={[dashboardStyles.dashboardWidget, style]}>
      <DashboardWidgetItem
        text={"Dashboard Overview"}
        icon={ic_dashboard}
        isActive={overviewIsActive}
        onClick={handleShowOverview}
      />
      <DashboardWidgetItem
        text={"Settings"}
        icon={ic_settings}
        isActive={settingsIsActive}
        onClick={handleShowSettings}
      />
      <DashboardWidgetItem
        text={"Report an Issue"}
        icon={ic_info_outline}
        isActive={reportIssueIsActive}
        onClick={handleShowReportIssue}
      />
      <DashboardWidgetItem
        text={"Tutorial"}
        icon={ic_help}
        isActive={false}
        onClick={handleShowTutorial}
      />
      <View style={{ flexGrow: 1, flexBasis: 0 }} />
      <DashboardWidgetItem
        text={"Log Out"}
        icon={ic_logout}
        isActive={false}
        onClick={handleLogout}
        border={"top"}
      />
    </View>
  );
}
